// src/components/ServicedNaLabel.jsx
//
// Shared inline label for serviced offices that have no tracked area.
// Use wherever a sqft or cost/sf value would otherwise be blank for a
// serviced_office location.
//
// Props:
//   compact  {boolean}  — when true, renders only "n/a" (no "· serviced" suffix)
//                         suitable for tight value slots like the BarRow value span
//   style    {object}   — additional styles applied to the outer <span>

import React from "react";
import { T } from "../app/tokens.js";

const TOOLTIP = "Serviced office - no footprint data";

export function ServicedNaLabel({ compact = false, style }) {
  return (
    <span title={TOOLTIP} style={style}>
      <span>n/a</span>
      {!compact && (
        <span style={{ color: T.light, fontSize: T.fsXxs }}>{" · serviced"}</span>
      )}
    </span>
  );
}
